module.exports = __webpack_public_path__ + "static/media/nodejs.45abcf13.png";